const Navigate = ({ to }) => {
  window.location = to;
  throw new Promise(() => {});
};

export default Navigate;
